import { initSentry } from "@holigral/shared/monitoring"

// The API is same-origin in every environment (profiling.wip locally,
// review.profiling.app / staging.profiling.app / profiling.app deployed), so
// propagate to our own hosts and nowhere else.
export default () => {
  initSentry({
    tracePropagationTargets: [/^https:\/\/([a-z0-9-]+\.)*profiling\.(app|wip)/],
  })
}
